// extracted by mini-css-extract-plugin
export default {"logotypeContainer":"Logotype_logotypeContainer__YM86j"};